"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  AppBar: {
    height: 56
  },
  Button: {
    height: 36,
    minWidth: 88
  }
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/style/Sizes.js
 ** module id = 181
 ** module chunks = 0
 **/